// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__HTQ12","buttons":"Footer_buttons__fL3ah"};